"use client";
import { useGetCompanyQuery } from "@/api/AppApi/services/company";
import { useCurrencyCalc } from "@/hooks/useCurrencyCalc";
import { useLang } from "@/providers/langProvider";
import Script from "next/script";
import { useEffect, useState } from "react";

type TTabbyCard = {
  new (options: {
    selector: string;
    currency: string;
    lang?: string;
    price: number;
    size: string;
    theme: string;
    header?: boolean;
  }): void;
};
declare global {
  interface Window {
    TabbyCard: TTabbyCard;
  }
}

type TProps = {
  price: number;
};

const TabbyCard: React.FC<TProps> = ({ price }) => {
  const { data } = useGetCompanyQuery();
  const convert = data?.result?.theme?.settings?.enable_currencies_converter;
  const { currency, convertToCurrentCurrency } = useCurrencyCalc({
    enable: data?.result?.theme?.settings?.enable_currencies_converter ?? true,
  });
  const lang = useLang();
  const [ready, setReady] = useState(false);
  useEffect(() => {
    if (ready) {
      new window.TabbyCard({
        selector: "#tabbyCard",
        currency: currency.code,
        lang,
        price: convert ? convertToCurrentCurrency(price) : price,
        size: "wide",
        theme: "black",
        header: false,
      });
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [price, lang, ready, currency.code]);
  return (
    <>
      <div id="tabbyCard" />

      {currency.code && (
        <Script
          src="https://checkout.tabby.ai/tabby-card.js"
          onReady={() => {
            setReady(true);
          }}
        />
      )}
    </>
  );
};

export default TabbyCard;
